/**
 * Keeps "Pure Simple Banner" sections in sync with the selected variant.
 *
 * Those banner sections live outside the <product-info> element, so the
 * default variant-change handling in product-info.js never touches them.
 * Any section that opts in via its "Refresh images when a variant is
 * selected" setting (data-sync-with-variant="true") is re-fetched through
 * the Section Rendering API whenever PUB_SUB_EVENTS.variantChange fires,
 * so dynamic sources bound to variant metafields resolve against the
 * newly selected variant.
 */
(function () {
  if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

  function refreshSection(sectionElement, variantId) {
    const sectionId = sectionElement.id.replace('shopify-section-', '');
    const url = `${window.location.pathname}?variant=${variantId}&section_id=${sectionId}`;

    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const newSection = html.getElementById(`shopify-section-${sectionId}`);
        if (newSection) {
          sectionElement.innerHTML = newSection.innerHTML;
        }
      })
      .catch((error) => console.error('Variant banner sync failed:', error));
  }

  subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
    const variant = event && event.data && event.data.variant;
    if (!variant || !variant.id) return;

    const seen = new Set();

    document.querySelectorAll('[data-sync-with-variant="true"]').forEach((trigger) => {
      const sectionElement = trigger.closest('.shopify-section');
      if (!sectionElement || seen.has(sectionElement)) return;
      seen.add(sectionElement);
      refreshSection(sectionElement, variant.id);
    });
  });
})();
